'use client';

import React from 'react';

import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { ExtendedLink } from '@/components/ExtendedLink';
import { ModuleHeader } from '@/components/ModuleHeader';
import {
  ActivityTrackerEventType,
  HomePageModuleNames,
} from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { type EbayUtmTag } from '@/modules/cms/types';
import { useYouMightBeIntoPills } from '@/modules/search/useYouMightBeIntoPills';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

const MINIMUM_VISIBLE_PILLS = 5;

type Props = {
  cohort?: EbayUtmTag;
  title?: string;
};

export function YouMightBeIntoPills({ cohort, title }: Props = {}) {
  const pills = useYouMightBeIntoPills(cohort);
  const t = useTranslations('home');
  const [, currentUser] = useCurrentUser();
  const { sendActivityTrackerEvent } = useActivityTracker({
    userId: currentUser?.id,
  });

  function handlePillClick(itemClicked: string, itemPosition: number) {
    sendActivityTrackerEvent(ActivityTrackerEventType.MODULE_CLICK_ACTION, {
      itemClicked,
      itemPosition,
      moduleName: HomePageModuleNames.BrandedCategories,
      schemaVersion: '3.0',
    });
  }

  if (pills.length < MINIMUM_VISIBLE_PILLS) {
    return null;
  }

  return (
    <section>
      <ModuleHeader title={title ?? t('YouMightBeInto.Title')} />
      <div className={styles.scrollableContainer}>
        <ul className={styles.pillList}>
          {pills.map((pill, index) => (
            <li key={pill.href}>
              <ExtendedLink
                href={pill.href}
                className={styles.pill}
                onClick={() => handlePillClick(pill.label, index)}
              >
                {pill.label}
              </ExtendedLink>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
